import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { errorUrlTree, guardRoundTrip } from '@mkp/shared/util-guards';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { vacancyExistsGuardActions } from '@mkp/vacancy/state/actions';
import { map, merge } from 'rxjs';
import {
  vacancyFromStore,
  vacancyLoadedFromGuard,
  vacancyLoadFromGuardFailed,
} from './vacancy-guard.helpers';

export const isVacancyExistingGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const actions$ = inject(Actions);
  const router = inject(Router);

  const vacancyId = route.paramMap.get('id') || route.queryParamMap.get('vacancy') || '';
  const notFound = () => errorUrlTree(router, 404);

  return guardRoundTrip({
    guardName: 'isVacancyExistingGuard',
    dispatchRequest: () => store.dispatch(vacancyExistsGuardActions.canActivate({ vacancyId })),
    outcome$: merge(
      vacancyFromStore(vacancyId, store),
      vacancyLoadedFromGuard(vacancyId, actions$),
      vacancyLoadFromGuardFailed(vacancyId, actions$).pipe(map(() => notFound()))
    ),
    onTimeout: notFound,
  });
};
